import * as React from 'react';
import {useState, useEffect} from 'react';
import {head} from 'ramda';
import {PanelContext} from 'react-popup-context';
import {ArrowLeft} from '../common/btns';
import Editor from './member-editor/editor';
import Viewer from './member-editor/viewer';
import * as User from '../lib/user';
import {result} from '../../lib/result';
import * as api from '../api';

const css = require('./member-editor.css').default;
const headerCss = require('../common/header.css').default;

type member = {
    name: string,
    email: string,
    isAdmin: boolean,
}

export default function({dealer, ctx}: {
    ctx: PanelContext,
    dealer: string,
}) {
    const [members, setMembers] = useState<member[]>([]);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        api.dealer.load(dealer)
        .then(setMembers);
    }, []);

    useEffect(() => {
        const user = User.load();
        const isAdmin = user ? head(members.filter(m => m.email === user.email))?.isAdmin || false : false;
        setIsAdmin(isAdmin);
    }, [members.length]);

    function edit(idx: number | null) {
        if (typeof idx === 'number') {
            ctx.popup(<Editor
                defaultValue={members[idx]}
                onDone={async m => {
                    const results = amend(members, idx, m);
                    const res = await api.dealer.save(dealer, results);
                    if (result.ok(res)) {
                        setMembers(results);
                    } else {
                        alert(res[0]);
                    }
                    ctx.close();
                }}
                onCancel={() => ctx.close()}
                onDel={async () => {
                    const ok = confirm('確定刪除?');
                    if (ok) {
                        const results = del(members, idx);
                        const res = await api.dealer.save(dealer, results);
                        if (result.ok(res)) {
                            setMembers(results);
                        } else {
                            alert(res[0]);
                        }
                        ctx.close();
                    }
                }}
            />);
        } else {
            ctx.popup(<Editor
                defaultValue={null}
                onDone={async m => {
                    const results = members.concat([m]);
                    const res = await api.dealer.save(dealer, results);
                    if (result.ok(res)) {
                        setMembers(results);
                    } else {
                        alert(res[0]);
                    }
                    ctx.close();
                }}
                onCancel={() => ctx.close()}
            />);
        }
    }

    function view(member: member) {
        ctx.popup(<Viewer member={member} onOk={() => ctx.close()}/>);
    }

    function amend<item>(items: item[], index: number, newValue: item) {
        return items.slice(0, index).concat(newValue, ...items.slice(index+1));
    }

    function del<item>(items: item[], index: number) {
        return items.slice(0, index).concat(items.slice(index+1));
    }

    return (
    <>
        <div id={headerCss.header}>
            <ArrowLeft width={25} height={25} onClick={() => ctx.close()}/>
            <div>權限設定</div>
            <div className='space'></div>
            {(() => {
                if (isAdmin) {
                    return <div id={css.add} onClick={() => edit(null)}>新增</div>;
                }
            })()}
        </div>
        <div>
            {(() => {
                return members
                .map((m, idx) => (
                    <Member key={idx} member={m}
                        onSelect={() => {
                            if (isAdmin) {
                                edit(idx);
                            } else {
                                view(m);
                            }
                        }}
                    />));
            })()}
        </div>
    </>);
}

function Member({member, onSelect}: {
    member: member,
    onSelect: () => void,
}) {
    return (
    <div className={css.member} onClick={onSelect}>
        <div>{member.name}&nbsp;&nbsp;({member.email})</div>
        <div>{member.isAdmin ? '管理員' : ''}</div>
    </div>);
}
